import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { getWindow } from 'ssr-window';
import { CommonExternalModule } from '../../common/common-external-module';
import { Subscription } from 'rxjs';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { CCAvenueDataFormat } from '../../Model/ccavenue-data-format';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CommonExternalModule],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.css'
})

export class PaymentComponent implements OnInit, OnDestroy {

  currentUrl: string;
  accessCode: string;
  orderid: string;
  data: any;
  sourceLogo: string | null | undefined;
  orderId: string;
  availabeAmount: number = 0;
  source: string;
  encRequest: string;
  isError: number = 0;

  @ViewChild("form") form: ElementRef;

  private ccavenueEncryptionDecryption: Subscription;

  constructor(
    private userService: UserService,
    private apiUrl: ApiFactoryEndPoints,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.currentUrl = getWindow().location.host;

    this.route.queryParams.subscribe(params => {
      this.data = params['data'];
      this.accessCode = params['access'];
      this.orderid = params['orderid'];
      this.sourceLogo = params['sourceLogo'];

      // ✅ CALL API ONLY AFTER params are set
      this.ccavenueEncryptionDecryption =
        this.userService.getCCAvenueDecrptData(this.apiUrl.decryptAnyData, this.data, this.orderid, this.currentUrl)
          .subscribe((data: any) => {
            if (data != "Invalid Data") {
              let obj: CCAvenueDataFormat = JSON.parse(data);
              let requestTimeTill = new Date(obj.validTill).getTime();
              let currentTime = new Date().getTime();
              if (requestTimeTill >= currentTime) {
                this.orderId = obj.orderId;
                this.availabeAmount = obj.amount;
                if (!obj.source) {
                  this.isError = 2;
                  return;
                }
                this.source = obj.source;

                this.getCCAvenueData(); // ⚠️ check inside this
              } else {
                this.isError = 1;
              }
            } else {
              this.isError = 2;
            }
          });
    });
  }

  ngOnDestroy(): void {
    if (this.ccavenueEncryptionDecryption) {
      this.ccavenueEncryptionDecryption.unsubscribe();
    }
  }

  getCCAvenueData() {
    this.ccavenueEncryptionDecryption = this.userService.getCCAvenueCred(this.apiUrl.ccAvenuePayment, this.orderId, this.availabeAmount.toString(), this.currentUrl)
      .subscribe((data: any) => {
        this.encRequest = data;

        setInterval(() => {
          if ((<HTMLInputElement>document.getElementById("encRequest")).value.length > 0 &&
            (<HTMLInputElement>document.getElementById("access_code")).value.length > 0 &&
            (<HTMLInputElement>document.getElementById("source")).value.length > 0)
            this.form.nativeElement.submit();
        }, 1000);

      });
  }

}